// Module
var code = "<md-progress-circular md-mode=\"indeterminate\" md-diameter=\"{{ ::size }}\"></md-progress-circular> ";
// Exports
module.exports = code;